import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import EventIcon from './EventIcon';

function formatDateRange(route) {
  const date1 = moment(route.start);
  const date2 = moment(route.end);
  let days = date1.format('MMM DD');
  if (!date2.isValid()) {
    return days;
  }
  if (!date1.isSame(date2)) {
    days = `${days}-${date2.format('DD')}`;
  }
  return days;
}

class EventMapItem extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.selected !== nextProps.selected && nextProps.selected) {
      this.node.scrollIntoView();
    }
  }
  onClick = () => {
    console.log('Event Clicked on:', this.props.event.id);
    this.props.onSelect(this.props.event.id);
  };
  render() {
    const event = this.props.event;
    console.log("event......................",event.events)
    const listBG = this.props.selected ? '#f0f0f0' : '';
    const eventName = this.props.eventName;
    const eventType = this.props.eventType;
    const note = () => {
      event.events.forEach(val =>{
        console.log("val............................",val)
        if(val.name == eventName){
          console.log("val.notes....................",val.notes)
          return val
        }
      })
    }
    const lebal = () =>{
        let location;
        if (this.props.event.place.city == null){
          location = `${this.props.event.place.state},${this.props.event.place.country}`;
        }
        if (this.props.event.place.state == null){
          location = `${this.props.event.place.city},${this.props.event.place.country}`;
        }
        if ( this.props.event.place.city == null && this.props.event.place.state == null && this.props.event.place.country == null){
          location = '';
        }
        if ( this.props.event.place.city != null && this.props.event.place.state != null && this.props.event.place.country != null){
          if (this.props.event.place.city === this.props.event.place.state){
            location = `${this.props.event.place.city}, ${this.props.event.place.country}`;
          }else{
            if (this.props.event.place.state === this.props.event.place.country){
              location = `${this.props.event.place.city}, ${this.props.event.place.country}`;
            } else{
                location = `${this.props.event.place.city}, ${this.props.event.place.state}, ${this.props.event.place.country}`;
              }  
          }
        }
        return location;
      }

    return (
      <li
        ref={node => (this.node = node)}
        key={event.id}
        className="map-item pointer-hover"
        data-route={event.id}
        onClick={this.onClick}
        style={{
          backgroundColor: listBG,
        }}
      >
        <div className="event-date" data-item={this.props.parentId}>
          <EventIcon eventType={eventType} />{' '}
          <strong className="event-day">{formatDateRange(event)}</strong>
        </div>
        <div className="event-location">
          <strong>
            <span>{eventName && eventName}</span>
          </strong>
          <br />
          <span>
            {lebal()}
            <br/>
          </span>
          {event.events.map((val) =>(
              <div>
                {val.name==eventName?(<span>{val.notes}</span>):('')}
              </div>
            ))
          }
        </div>
      </li>
    );
  }
}

EventMapItem.propTypes = {
  selected: PropTypes.bool.isRequired,
  event: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    event_type: PropTypes.string
  }).isRequired,
  eventName: PropTypes.string,
  eventType: PropTypes.string,
  parentId: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
};
EventMapItem.defaultProps = {
  parentId: null,
};
export default EventMapItem;



// WEBPACK FOOTER //
// src/routes/tours/components/EventMapItem.js